import { Option, Select } from '@repo/ui';
import { Col, Label } from 'reactstrap';

interface CourseAndGroupFiltersProps {
  groups: Option[];
  courses: Option[];
  groupSelectValue: Option | Option[];
  courseSelectValue: Option | Option[];
  isCourseSelectMulti?: boolean;
  isGroupSelectMulti?: boolean;
  onGroupChange: (group: Option | Option[] | null) => void;
  onCourseChange: (course: Option | Option[] | null) => void;
  isCourseSelectLoading?: boolean;
  isGroupSelectLoading?: boolean;
  courseDefaultValue?: Option | null;
  groupDefaultValue?: Option | null;
}

export const CourseAndGroupFilters = ({
  groups,
  courses,
  isCourseSelectMulti,
  isGroupSelectMulti,
  onGroupChange,
  groupSelectValue,
  onCourseChange,
  courseSelectValue,
  isCourseSelectLoading,
  isGroupSelectLoading,
  courseDefaultValue = null,
  groupDefaultValue = null,
}: CourseAndGroupFiltersProps) => {
  const coursesLength = courses.length;
  const groupsLength = groups.length;

  return (
    <>
      <Col md={6}>
        <Label className="form-label">Curso</Label>
        <Select
          options={courses}
          value={courseSelectValue}
          placeholder={coursesLength > 1 ? 'Todos os Cursos' : ''}
          isClearable={coursesLength > 1}
          isDisabled={isCourseSelectLoading}
          isLoading={isCourseSelectLoading}
          isMulti={coursesLength === 1 ? false : isCourseSelectMulti}
          onChange={(course) => {
            onCourseChange(course);
          }}
          defaultValue={coursesLength === 1 ? courses[0] : courseDefaultValue}
        />
      </Col>

      <Col md={6}>
        <Label className="form-label">Grupo</Label>
        <Select
          options={groups}
          value={groupSelectValue}
          placeholder={groupsLength > 1 ? 'Todos os Grupos' : ''}
          isClearable={groupsLength > 1}
          isDisabled={isGroupSelectLoading}
          isLoading={isGroupSelectLoading}
          isMulti={groupsLength === 1 ? false : isGroupSelectMulti}
          onChange={(group) => {
            onGroupChange(group);
          }}
          defaultValue={groupsLength === 1 ? groups[0] : groupDefaultValue}
        />
      </Col>
    </>
  );
};
